import { Box, Stack } from "@mui/material";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import {
  Hand,
  Pile,
  River,
  Stuck,
  Work,
  nertzPlayerMessage,
} from "../../api/NertzApi";
import CardSlot from "../../cmp/CardSlot";
import PlayingCard from "../../cmp/PlayingCard";
import { DragCard } from "../../api/CardApi";
import { useParams } from "react-router-dom";

const cardTypes = ["hand", "nertz", "work"];

function NertzRiver() {
  const params = useParams(),
    [river, setRiver] = useRecoilState(River),
    dragCard = useRecoilValue(DragCard),
    [hand, setHand] = useRecoilState(Hand),
    [pile, setPile] = useRecoilState(Pile),
    [work, setWork] = useRecoilState(Work),
    setStuck = useSetRecoilState(Stuck),
    handleOver = (e, i) => {
      if (dragCard && cardTypes.indexOf(dragCard.cardType) > -1) {
        const card = river[i];

        if (
          (!card && dragCard.rank === 1) ||
          (dragCard.rank - card.rank === 1 && card.suit === dragCard.suit)
        ) {
          e.preventDefault();
        }
      }
    },
    handleDrop = (e, i) => {
      let payload = {
        river: {
          index: i,
          rank: dragCard.rank,
          suit: dragCard.suit,
        },
      };

      setRiver(
        river.map((r, index) =>
          i === index
            ? {
                rank: dragCard.rank,
                suit: dragCard.suit,
              }
            : r
        )
      );

      setStuck(false);

      switch (dragCard.cardType) {
        case "hand":
          setHand(hand.slice(0, -1));
          payload = {
            ...payload,
            ...{
              score: {
                score: 1,
              },
            },
          };

          break;
        case "nertz":
          setPile(pile.slice(1));
          payload = {
            ...payload,
            ...{
              score: {
                nertz: 1,
                score: 3,
              },
            },
          };

          break;
        case "work":
          setWork(
            work.map((w) =>
              w.some(
                (s) => s.rank === dragCard.rank && s.suit === dragCard.suit
              )
                ? w.slice(0, -1)
                : w
            )
          );
          payload = {
            ...payload,
            ...{
              score: {
                score: 1,
              },
            },
          };

          break;
        default:
          break;
      }

      nertzPlayerMessage(params.id, payload);

      e.preventDefault();
    };

  return (
    <Stack
      id="nertz-river"
      direction="row"
      sx={{
        borderRadius: 1,
        width: 1,
      }}
    >
      <Box sx={{ flexGrow: 1 }} />
      <Stack
        direction="row"
        spacing={1}
        sx={{
          p: 1,
        }}
      >
        {river.map((r, i) =>
          r ? (
            <PlayingCard
              cardType="river"
              key={`riverCard${i}`}
              rank={r.rank === 13 ? 0 : r.rank}
              suit={r.rank === 13 ? 0 : r.suit}
              onDragOver={(e) => {
                handleOver(e, i);
              }}
              onDrop={(e) => {
                handleDrop(e, i);
              }}
            />
          ) : (
            <CardSlot
              key={`riverCard${i}`}
              onDragOver={(e) => {
                handleOver(e, i);
              }}
              onDrop={(e) => {
                handleDrop(e, i);
              }}
            />
          )
        )}
      </Stack>
      <Box sx={{ flexGrow: 1 }} />
    </Stack>
  );
}

export default NertzRiver;
